(function () {
  document.addEventListener("DOMContentLoaded", function () {
    const closeAll = () => {
      document
        .querySelectorAll(".express-shipping-tooltip.is-open")
        .forEach((el) => {
          el.classList.remove("is-open");
          const triggerButton = el.querySelector(
            ".express-shipping-tooltip__trigger",
          );
          triggerButton?.setAttribute("aria-expanded", "false");
        });
    };

    document.body.addEventListener("keydown", function (e) {
      if (e.key === "Escape") closeAll();
    });

    document.body.addEventListener("click", function (e) {
      const target = e.target;

      if (!(target instanceof Element)) {
        return;
      }

      const trigger = target.closest(".express-shipping-tooltip__trigger");
      const tooltip = target.closest(".express-shipping-tooltip__content");

      if (trigger) {
        const wrapper = trigger.closest(".express-shipping-tooltip");
        if (!wrapper) return;
        const isOpen = wrapper.classList.contains("is-open");
        closeAll();
        if (!isOpen) {
          wrapper.classList.add("is-open");
          trigger.setAttribute("aria-expanded", "true");
        }
        return;
      }

      if (tooltip) return;

      closeAll();
    });
  });
})();
